import { create } from 'zustand';

const useAppStore = create((set) => ({
  // State
  appStatus: 'loading',
  settings: null,
  personalizationActive: false,
  pricingTriggered: false,

  // Actions
  setAppStatus: (appStatus) => set({ appStatus }),
  setSettings: (settings) => set({ settings }),
  setPersonalizationActive: (personalizationActive) => set({ personalizationActive }),
  setPricingTriggered: (pricingTriggered) => set({ pricingTriggered }),
}));

export default useAppStore;
